import { Climate } from "./apps/Climate.js";
import { Gate } from "./apps/Gate.js";
import { IconList } from "./apps/IconList.js";
import { Links } from "./apps/Links.js";
import { Stepper } from "./apps/Stepper.js";
import { PanelValue, Panels } from "./display/Panels.js";
import { Assets } from "./model/Assets.js";
import { Config } from "./model/Config.js";
import { Data } from "./model/Data.js";
import { IData } from "./model/DataStructure.js";
import { Language, LanguageCode } from "./model/Language.js";
import { Ressource } from "./model/Ressource.js";

export class Application {
    public data: Data;

    constructor() {
        Ressource.init();

        (window as any).$ = jQuery;

        this.data = new Data();
        this.data.onComplete.add((data) => this.onDataLoaded(data));
        this.data.load(Ressource.DATA);
    }

    private onDataLoaded(data: IData): void {
        Assets.init(data);

        document.body.addEventListener("scroll", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            document.body.scrollTop = 0;
        }, { passive: false, capture: true });

        window.addEventListener("resize", () => this.scaleToFit());

        Config.configTitle = e5.Url.params.get("config", Config.configTitle);
        Config.init(e5.array.match(data.config, "title", Config.configTitle), data.gate, data.stepper, data.climate);
        Config.language = e5.Url.params.get("language", Config.language) as LanguageCode;
        Language.init(data.ui_label, Config.language);

        const panel: PanelValue = e5.Url.params.get("panel", Panels.LINKS) as PanelValue;
        if (panel == Panels.CLIMATE) {
            new Climate(Config.climate);
        }
        else if (panel == Panels.STEPPER) {
            new Stepper(Config.stepper);
        }
        else if (panel == Panels.GATE) {
            new Gate(Config.gate);
        }
        else if (panel == Panels.ICONS) {
            new IconList();
        }
        else {
            new Links();
        }

        this.scaleToFit();
    }

    private scaleToFit(): void {
        var elements = document.querySelectorAll<HTMLElement>(".scale-to-fit") as any;
        var w = window.innerWidth;
        var h = window.innerHeight;

        for (var element of elements) {
            var elementWidth = 3840;
            var elementHeight = 2160;
            if (element.classList.contains("vertical")) {
                elementWidth = 2160;
                elementHeight = 3840;
            }

            var scale = Math.min(w / elementWidth, h / elementHeight);
            if (scale == 1) {
                element.style.transform = "initial";
            }
            else {
                var x = (w - elementWidth * scale) * 0.5;
                var y = (h - elementHeight * scale) * 0.5;
                element.style.transform = "translate(" + x + "px, " + y + "px) scale(" + scale + ")";
            }

            element.setAttribute("data-scale", scale.toString());
        }
    }
}

document.addEventListener("DOMContentLoaded", (): void => {
    var application = new Application();
});